export const BASE_API_URL: string | undefined = process.env.NEXT_PUBLIC_API_URL;

export type Endpoint = {
  url: string;
};
